<template>
  <div class="result-display-container">
    <div v-if="isLoading" class="loading-container">
      <div class="loading-spinner">
        <div class="gradient-circle"></div>
        <div class="loading-text">
          {{ $t("generatingYouriImage") }}
        </div>
        <div class="loading-tips">
          {{ $t("generateTips") }}
        </div>
      </div>
    </div>
    <div v-else-if="imageSrc" class="result-image-container">
      <img :src="imageSrc" class="result-image" alt="Generated result">
      <div class="download-overlay">
        <button class="btn block-btn" @click="downloadImage">
          {{ $t("downloadImage") }}
        </button>
      </div>
    </div>
    <div v-else class="no-result-placeholder">
      <p class="no-image-text">
        {{ $t("noImageGenerated") }}
      </p>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    imageSrc: {
      type: String,
      required: false,
      default: '',
    },
    isLoading: {  // 新增 isLoading prop 來同步加載狀態
      type: Boolean,
      default: false
    }
  },
  methods: {
    /** 下載圖片 */
    downloadImage() {
      if (this.imageSrc) {
        const link = document.createElement('a');
        link.href = this.imageSrc;
        link.download = `generated_image_${Date.now()}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
  }
};
</script>

